import { render } from "./FileExplorerElementIcon.vue?vue&type=template&id=158c6b10&scoped=true"
import script from "./FileExplorerElementIcon.vue?vue&type=script&lang=js"
export * from "./FileExplorerElementIcon.vue?vue&type=script&lang=js"

import "./FileExplorerElementIcon.vue?vue&type=style&index=0&id=158c6b10&scoped=true&lang=scss"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158c6b10"]])

export default __exports__